import React from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import AdminLayoutWrapper from '../Admin/AdminLayoutWrapper'

class ApiDocViewerPage extends React.Component {

  state = {
    typingStr: '',
    apiDocUrl: null,
  }


  loadApiDocument = () => {
    this.setState({apiDocUrl: this.state.typingStr});
  }

  handleInputChange = (e) => {
    this.setState({typingStr: e.target.value});
  }

  render() {
    const apiDocUrl = this.state.apiDocUrl;

    return (
      <AdminLayoutWrapper>
        <div className="row">
          <div className="col-8">
            <input 
              className="form-control"
              placeholder="Paste the api doc url"
              value={this.state.typingStr}
              onChange={this.handleInputChange}
            />
          </div>
          <div className="col-4">
            <button className="btn btn-primary" onClick={this.loadApiDocument}>Explore</button>
          </div>
        </div>
        {
          apiDocUrl != null ? (
            <div id="swagger_doc" style={{background: 'white', padding: '5px', margin: '10px'}}>
              <SwaggerUI url={apiDocUrl}/>
            </div>) : null
        }
      </AdminLayoutWrapper>
    )
  }
}

export default ApiDocViewerPage;